var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterConfirmCountry.tsx";
import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { CheckboxListItem as Checkbox, Text } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { CountryBottomSheetModal, FormContainer, RichText } from 'Components/utility';
import { SelectorInput } from 'Components/utility/SelectorInput';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
import { ContentContainer } from '../helpers';
const RegisterConfirmCountry = ({
  formikForm,
  setLoading,
  countries
}) => {
  const {
    values,
    setFieldValue
  } = formikForm;
  const [isBottomSheetModalOpen, setIsBottomSheetModalOpen] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const onCancelBottomSheetModal = useCallback(() => {
    setIsBottomSheetModalOpen(false);
  }, []);
  const onSelectCountry = useCallback(async selectedCountry => {
    try {
      setIsBottomSheetModalOpen(false);
      setLoading(true);
      const {
        app,
        appVersion,
        deviceManufacturer,
        deviceModel,
        osType,
        osVersion
      } = store.getState().env;
      await updateConfig(true, selectedCountry, app, appVersion, deviceManufacturer, deviceModel, osType, osVersion);
      setFieldValue('country', selectedCountry);
      setLoading(false);
    } catch {
      showApiErrorModal();
      setLoading(false);
    }
  }, [setFieldValue, setLoading, showApiErrorModal]);
  const countryFromApp = useSelector(state => state.env.country);
  const selectorValue = useMemo(() => {
    const country = values.country || countryFromApp;
    return country ? i18n.t(`Global.microcopy.countries.${country.toUpperCase()}`) : '';
  }, [countryFromApp, values.country]);
  return /*#__PURE__*/React.createElement(ContentContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 7
    }
  }, i18n.t('ConfirmCountry.subtitle')), /*#__PURE__*/React.createElement(FormContainer, {
    hasHiddenUserInput: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SelectorInput, {
    testID: "ConfirmCountry",
    label: i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    placeholder: i18n.t('ConfirmCountry.content.selectCountry.secondaryText'),
    "aria-label": i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
    value: selectorValue,
    onClick: () => setIsBottomSheetModalOpen(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 9
    }
  }, () => {
    return /*#__PURE__*/React.createElement(CountryBottomSheetModal, {
      title: i18n.t('ConfirmCountry.content.selectCountry.primaryText'),
      selectedCountry: values.country,
      isOpen: isBottomSheetModalOpen,
      onCancel: onCancelBottomSheetModal,
      onDone: onSelectCountry,
      countries: countries,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 15
      }
    });
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: values.confirmCountryChecked,
    testID: "ConfirmCountry.checkBox"
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    title: /*#__PURE__*/React.createElement(RichText, {
      text: i18n.t('ConfirmCountry.content.selectCountry.bodyText'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 111,
        columnNumber: 13
      }
    }),
    disabled: !values.country,
    onPress: () => setFieldValue('confirmCountryChecked', !values.confirmCountryChecked),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 9
    }
  })));
};
export { RegisterConfirmCountry };